<template>
  <div class="dashboard-screen">
    <header class="screen-header">
      <div class="header-left-info">
        <div class="brand-logo-wrap">
          <span class="g-letter">G</span>
          <span class="p-letter">P</span>
          <span class="s-letter">S</span>
          <span class="factory-text">幸福工厂</span>
        </div>
        <div class="header-line"></div>
      </div>
      
      <div class="header-center-area">
        <h1 class="main-title">智味食空</h1>
        <div class="title-bottom-bar">
          <div class="dot left"></div>
          <div class="bar-line"></div>
          <div class="dot right"></div>
        </div>
      </div>

      <div class="header-right-info">
        <div class="header-line"></div>
        <span class="time-text">{{ currentTime }}</span>
      </div>
    </header>

    <el-row :gutter="20" class="screen-body">
      <el-col :span="6" class="full-height-col">
        <div class="glass-card flex-1">
          <div class="module-title">当日销量Top5</div>
          <div class="top5-container">
            <div v-for="(item, i) in topDishes" :key="i" class="top5-item">
              <div class="food-img-wrapper">
                <img :src="item.url" class="food-img" alt="food" />
                <div class="rank-tag">Top{{ i + 1 }}</div>
              </div>
              <div class="food-info">{{ item.name }}</div>
            </div>
          </div>
        </div>
        <div class="glass-card flex-1 mt-20">
          <div class="module-title">公告栏</div>
          <div class="notice-content">
            <div class="notice-paper">
              <p>暂无最新公告内容...</p>
            </div>
          </div>
        </div>
      </el-col>

      <el-col :span="12" class="full-height-col">
        <div class="glass-card flex-1-5">
          <div class="center-title">每日菜单</div>
          <div class="menu-table">
            <div class="menu-group">
              <div class="menu-label hot">热菜</div>
              <div class="menu-values">
                <span v-for="d in hotDishes" :key="d">{{ d }}</span>
              </div>
            </div>
            <div class="menu-group mt-20">
              <div class="menu-label fruit">水果</div>
              <div class="menu-values">
                <span>凤梨</span><span>葡萄</span>
              </div>
            </div>
          </div>
        </div>
        
        <div class="glass-card flex-2 mt-20">
          <div class="center-title">餐位热度</div>
          <div class="heat-layout">
            <div class="heat-stats-panel">
              <div class="stats-label">瞬时上限 800</div>
              <div class="stats-label mt-10">当前人数</div>
              <div class="digital-display">
                <div class="digital-bg">888</div>
                <div class="digital-val">003</div>
              </div>
            </div>
            <div class="heat-grid-panel">
              <div v-for="z in zones" :key="z.name" class="zone-box-new">
                <div class="zone-head-new">
                  <span class="z-name">{{z.name}}区</span>
                  <span class="z-per">{{z.per}}%</span>
                </div>
                <div class="user-line-new">
                  <i v-for="n in 12" :key="n" 
                     class="el-icon-user-solid" 
                     :class="{active: n <= (z.name === 'A' ? 2 : z.name === 'D' ? 1 : 0)}">
                  </i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>

      <el-col :span="6" class="full-height-col">
        <div class="glass-card flex-1">
          <div class="module-title">后厨监控</div>
          <div class="monitor-screen">
            <div class="monitor-overlay">LIVE</div>
            <i class="el-icon-video-play"></i>
            <p>监控画面同步中...</p>
          </div>
        </div>
        <div class="glass-card flex-1 mt-20">
          <div class="module-title">设备烹饪</div>
          <div class="device-scroll">
            <div v-for="dev in devices" :key="dev.name" class="device-row">
              <span class="dev-name">{{ dev.name }}</span>
              <div class="dev-status-tag" :class="dev.status">
                {{ dev.status === 'idle' ? '空闲' : '离线' }}
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentTime: new Date().toLocaleTimeString(),
      // 优化的美食图片素材数据
      topDishes: [
        { name: '平菇炒肉', url: 'https://images.unsplash.com/photo-1606471191009-63994c51401f?auto=format&fit=crop&w=200&q=80' },
        { name: '蒜苗炒鸡蛋', url: 'https://images.unsplash.com/photo-1525351484163-7529414344d8?auto=format&fit=crop&w=200&q=80' },
        { name: '点心', url: 'https://images.unsplash.com/photo-1559622214-f8a9850965bb?auto=format&fit=crop&w=200&q=80' },
        { name: '山楂红烧肉', url: 'https://images.unsplash.com/photo-1544025162-d76694265947?auto=format&fit=crop&w=200&q=80' },
        { name: '清炒菜心', url: 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?auto=format&fit=crop&w=200&q=80' }
      ],
      hotDishes: ['山楂红烧肉', '五香鲅鱼', '三杯鸡', '辣炒鸡胗', '肉沫茄子', '外婆菜炒毛豆', '青椒煎蛋', '平菇炒肉'],
      zones: [
        { name: 'A', per: '1.75' }, { name: 'B', per: '0.00' },
        { name: 'C', per: '0.00' }, { name: 'D', per: '0.48' }
      ],
      devices: [
        { name: '6-食光机', status: 'idle' },
        { name: '3-温芯小厨', status: 'idle' },
        { name: '7-味来大师', status: 'offline' },
        { name: '味能大师', status: 'offline' }
      ]
    };
  },
  mounted() {
    setInterval(() => {
      this.currentTime = new Date().toLocaleTimeString();
    }, 1000);
  }
};
</script>

<style scoped>
/* 容器调整 */
.dashboard-screen {
  background: #eaeff3;
  height: 100vh;
  padding: 10px 25px 25px 25px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;
}

/* =========================================
    Logo 拼色与 Header 样式
   ========================================= */
.screen-header {
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  margin-bottom: 15px;
  background: rgba(255, 255, 255, 0.4);
  border-radius: 4px;
}

.brand-logo-wrap {
  display: flex;
  align-items: baseline;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: 900;
  font-size: 26px;
}
.g-letter { color: #006633; } /* 深绿 */
.p-letter { color: #006633; } /* 深绿 */
.s-letter { color: #99CC00; margin-right: 10px; } /* 亮绿 */
.factory-text { 
  color: #333; 
  font-size: 18px; 
  font-weight: bold;
  letter-spacing: 0px;
}

.header-left-info, .header-right-info {
  display: flex;
  align-items: center;
  gap: 15px;
  flex: 1;
}

.header-right-info { justify-content: flex-end; }
.time-text {
  font-size: 16px;
  font-weight: bold;
  color: #5a6d81;
  font-family: 'Courier New', Courier, monospace;
}

.header-line {
  height: 2px;
  flex: 1;
  background: linear-gradient(to right, transparent, rgba(243, 152, 0, 0.4), transparent);
}

.header-center-area {
  padding: 0 40px;
  text-align: center;
}

.main-title {
  font-size: 32px;
  font-weight: bold;
  color: #f39800;
  margin: 0;
  letter-spacing: 6px;
}

.title-bottom-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.bar-line { width: 120px; height: 3px; background: #f39800; border-radius: 2px; }
.dot { width: 4px; height: 4px; background: #f39800; transform: rotate(45deg); }

/* =========================================
    销量榜图片显示优化
   ========================================= */
.top5-item {
  margin-bottom: 5px;
}
.food-img-wrapper {
  background: #fff;
  height: 80px;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  border: 1px solid #eee;
}
.food-img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* 确保图片不变形铺满 */
}
.food-info { 
  font-size: 13px; 
  margin-top: 5px; 
  color: #444; 
  font-weight: bold;
  text-align: center;
}

/* 其他区块样式保持稳定 */
.screen-body { flex: 1; display: flex; }
.full-height-col { display: flex; flex-direction: column; height: 100%; }

.glass-card {
  background: #ffffff;
  border-radius: 6px;
  border-top: 4px solid #f39800;
  box-shadow: 0 6px 20px rgba(0,0,0,0.06);
  padding: 20px;
  display: flex;
  flex-direction: column;
}
.flex-1 { flex: 1; }
.flex-1-5 { flex: 1.5; }
.flex-2 { flex: 2; }
.mt-20 { margin-top: 20px; }

.module-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  border-left: 5px solid #f39800;
  padding-left: 12px;
  margin-bottom: 20px;
}
.center-title {
  text-align: center;
  color: #f39800;
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 25px;
}

.top5-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
  flex: 1;
}

.rank-tag {
  position: absolute;
  top: 5px; right: 5px;
  background: rgba(243, 152, 0, 0.9);
  color: #fff;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 10px;
  font-weight: bold;
}

.menu-group { display: flex; align-items: flex-start; }
.menu-label {
  padding: 2px 10px;
  border-radius: 4px;
  font-weight: bold;
  margin-right: 20px;
  font-size: 15px;
}
.menu-label.hot { color: #f39800; background: #fff5e6; }
.menu-label.fruit { color: #67c23a; background: #f0f9eb; }
.menu-values {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 15px;
  color: #555;
  font-size: 15px;
}

.heat-layout { display: flex; flex: 1; align-items: center; justify-content: space-around; }
.heat-stats-panel { padding: 15px 25px; background: #f8f9fa; border-radius: 8px; border: 1px solid #eee; text-align: left; }
.stats-label { color: #666; font-size: 14px; font-weight: bold; }
.mt-10 { margin-top: 10px; }

.digital-display { position: relative; margin-top: 8px; background: #fff; padding: 5px 15px; border: 1px solid #ddd; border-radius: 4px; display: inline-block; }
.digital-bg { font-family: 'Courier New', Courier, monospace; font-size: 72px; font-weight: bold; color: #f2f2f2; letter-spacing: 4px; }
.digital-val { position: absolute; top: 5px; left: 15px; font-family: 'Courier New', Courier, monospace; font-size: 72px; font-weight: bold; color: #f39800; letter-spacing: 4px; text-shadow: 0 0 10px rgba(243, 152, 0, 0.3); }

.heat-grid-panel { flex: 1; padding-left: 50px; display: grid; grid-template-columns: 1fr 1fr; gap: 20px 40px; }
.zone-box-new { margin-bottom: 5px; }
.zone-head-new { display: flex; justify-content: space-between; width: 100%; max-width: 180px; margin-bottom: 8px; }
.z-name { font-weight: bold; color: #333; font-size: 15px; }
.z-per { color: #999; font-size: 13px; }
.user-line-new i { font-size: 20px; color: #e9e9e9; margin-right: 3px; }
.user-line-new i.active { color: #f39800; }

.monitor-screen { flex: 1; background: #1a1a1a; border-radius: 6px; display: flex; flex-direction: column; justify-content: center; align-items: center; color: #555; position: relative; }
.monitor-overlay { position: absolute; top: 10px; left: 10px; color: #ff4d4d; font-size: 12px; border: 1px solid #ff4d4d; padding: 2px 5px; }
.monitor-screen i { font-size: 40px; margin-bottom: 10px; }

.device-row { display: flex; justify-content: space-between; align-items: center; padding: 12px 0; border-bottom: 1px solid #f2f2f2; }
.dev-status-tag { padding: 4px 12px; border-radius: 4px; font-size: 12px; }
.dev-status-tag.idle { background: #f0f9eb; color: #67c23a; }
.dev-status-tag.offline { background: #fef0f0; color: #f56c6c; }
</style>